export const contactConstants = {
  CONTACT_REQUEST: "CONTACT_REQUEST",
  CONTACT_SUCCESS: "CONTACT_SUCCESS",
  CONTACT_FAILURE: "CONTACT_FAILURE",

};
